<template>
  <div>
    <el-dialog
      :title="`Credit Records: ${number} - ${name} - 餘額: ${credits}`"
      :visible.sync="dialogRecordVisibleProp"
      width="80%"
      :append-to-body="true"
      :before-close="handleClose"
      :close-on-click-modal="false"
      @open="open()"
    >
      <el-table
        :data="data"
        border
        fit
        highlight-current-row
        style="width:100%;height:300px;margin-top:30px;overflow-y:scroll;"
      >
        <el-table-column align="center" label="時間" width="250">
          <template slot-scope="scope">
            <span>{{ scope.row.createdAt }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="動作" width="110">
          <template slot-scope="scope">
            <span>{{ scope.row.typeName }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="類型" width="110">
          <template slot-scope="scope">
            <span>{{ scope.row.statusName }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="點數變化" width="110">
          <template slot-scope="scope">
            <span>{{ scope.row.credits }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="備註" width="110">
          <template slot-scope="scope">
            <span>{{ scope.row.memo }}</span>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'RecordDialog',
  props: {
    dialogRecordVisibleProp: {
      type: Boolean,
      default: false
    }
  },
  data: function() {
    return {
      number: '',
      name: '',
      credits: 0,
      data: []
    }
  },
  methods: {
    open() {
      this.number = this.$parent.currentRecordNumber
      this.name = this.$parent.currentRecordName
      this.credits = this.$parent.currentRecordCredits
      this.data = this.$parent.currentRecordItem
      console.log(this.data)
    },
    handleClose(done) {
      this.$parent.dialogRecordVisible = false
    }
  }
}
</script>
